module.exports = $;


/*****************
 ** WEBPACK FOOTER
 ** external "$"
 ** module id = 62
 ** module chunks = 0
 **/